import { render, staticRenderFns } from "./MusicSetting.vue?vue&type=template&id=6f6f5276&scoped=true&"
import script from "./MusicSetting.vue?vue&type=script&lang=ts&"
export * from "./MusicSetting.vue?vue&type=script&lang=ts&"
import style0 from "./MusicSetting.vue?vue&type=style&index=0&id=6f6f5276&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f6f5276",
  null
  
)

export default component.exports